// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__23nI1","list":"styles_list__3v7_i"};